import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import { JawsSegmentationResponse } from '@/schema/jawsSegmentation';
import JawsCorrection from './JawsCorrection';
import { correctionStore } from '@bracesDesigner/correction/store/correctionState.ts';
import CorrectionService from './CorrectionService';

export class CorrectionScene extends BaseThreeScene {
  private jawsCorrection?: JawsCorrection;
  private correctionService: CorrectionService;

  constructor(container: HTMLElement) {
    super(container);
    this.correctionService = new CorrectionService();
    this.root.camera.position.set(0, 0, 150);
    this.root.renderer.setClearColor('#0b1120');
  }

  public async init(segmentation: JawsSegmentationResponse) {
    this.jawsCorrection = await this.correctionService.createJawsCorrection(segmentation);
    correctionStore.getState().setJaws(this.jawsCorrection);
    this.jawsCorrection.setUpdateJawsStore(correctionStore.getState().updateStore);
    this.startRendering();
  }

  public dispose() {
    super.dispose();
  }
}
